import React from 'react';
import {_has, _isNil} from "../../../../utils/helpers/zupeeLodash"
import NiceAnimation from './NiceAnimation';
import ShabashAnimation from './ShabashAnimation';
import WellDoneAnimation from './WellDoneAnimation';
import BahutBadhiyaAnimation from './BahutBadhiyaAnimation';
import GreatJobAnimation from './GreatJobAnimation';
import JabardastAnimation from './JabardastAnimation';
import { useSelector } from 'react-redux';
import { getHomeAnimationConfig } from '../../../../store/selectors/ludoboardSelectors';
import { NX_HOME_ANIMATION_TYPE } from '../../../../pages/GamePlay/types';

const ANIMATION_MAP = {
  [NX_HOME_ANIMATION_TYPE.NICE]: NiceAnimation,
  [NX_HOME_ANIMATION_TYPE.SHABASH]: ShabashAnimation,
  [NX_HOME_ANIMATION_TYPE.WELL_DONE]: WellDoneAnimation,
  [NX_HOME_ANIMATION_TYPE.BAHUT_BADHIYA]: BahutBadhiyaAnimation,
  [NX_HOME_ANIMATION_TYPE.GREAT_JOB]: GreatJobAnimation,
  [NX_HOME_ANIMATION_TYPE.JABARDAST]: JabardastAnimation,
};

// interface HomeAnimationProps {
//   animationType: NX_HOME_ANIMATION_TYPE | null;
// }

const HomeAnimation: React.FC = () => {
  const homeAnimationConfig = useSelector(getHomeAnimationConfig);

  if (!(homeAnimationConfig?.nxHomeAnimationType) || !_has(ANIMATION_MAP, homeAnimationConfig?.nxHomeAnimationType)) {
    return null
  }
  const Animation = ANIMATION_MAP[homeAnimationConfig?.nxHomeAnimationType]

  return <Animation />;
};

export default HomeAnimation;